import { formatCurrency } from '@/domains/core/localization/currency';
import { getMarket, getPlatform } from '@/domains/core/settings/utils';
import { Skeleton } from '@/domains/core/tamagoshiTailwind/components/Skeleton/Skeleton';
import { useLoyaltyProgramCardQuery } from '@/domains/loyalty/modules/LoyaltyProgramHvc/components/LoyaltyProgramCard/generated/loyaltyProgramCard.query.generated';
import {
  loyaltyCardCashbackPercentage,
  loyaltyCardWalletAmount,
  loyaltyCardWelcomeOffer,
} from '@/domains/loyalty/modules/LoyaltyProgramHvc/components/LoyaltyProgramCard/translations';
import { loyaltyCardContentFormatter } from '@/domains/loyalty/modules/LoyaltyProgramHvc/components/LoyaltyProgramCard/utils';
import { useLoyaltyProgramHvcWelcomeOffer } from '@/domains/loyalty/modules/LoyaltyProgramHvc/hooks/useLoyaltyProgramHvcWelcomeOffer';
import type { Channel, Market, Platform } from '@/generated/graphql/types';

export const LoyaltyProgramCardContent = () => {
  const welcomeOfferAmount = useLoyaltyProgramHvcWelcomeOffer();

  const [{ data, fetching }] = useLoyaltyProgramCardQuery({
    variables: {
      platform: getPlatform().toUpperCase() as Platform,
      market: getMarket().toUpperCase() as Market,
      channel: 'WEB' as Channel,
      userSegments: {},
    },
    requestPolicy: 'cache-and-network',
  });

  const isSaleToDisplayOnCard = data?.loyaltyHVCOffers?.find(
    (element) => element.displayInCard === true,
  );

  const currentLevelHasCashback =
    !!data?.loyaltyHVCLevelStatus?.level.cashbackPercentage;

  let content = null;

  if (isSaleToDisplayOnCard) {
    content = welcomeOfferAmount
      ? loyaltyCardWelcomeOffer.format(
          loyaltyCardContentFormatter({
            amount: formatCurrency(
              isSaleToDisplayOnCard.amount || welcomeOfferAmount,
              undefined,
              {
                minimumFractionDigits: 0,
              },
            ),
          }),
        )
      : null;
  } else if (data?.loyaltyWallet) {
    content =
      data.loyaltyWallet.amount === 0 && currentLevelHasCashback
        ? loyaltyCardCashbackPercentage.format(
            loyaltyCardContentFormatter({
              percentage: '3%',
            }),
          )
        : loyaltyCardWalletAmount.format(
            loyaltyCardContentFormatter({
              amount: formatCurrency(data.loyaltyWallet.amount),
            }),
          );
  } else if (fetching) {
    content = <Skeleton.Block height={46} />;
  }

  return <div className="flex flex-col">{content}</div>;
};

LoyaltyProgramCardContent.displayName = 'LoyaltyProgramCardContent';
